import { Component, OnDestroy, OnInit } from '@angular/core';

import { Observable, Subject, Subscription, switchMap, take } from 'rxjs';
import { Store } from '@ngrx/store';

import { ButtonSize, ButtonTheme, LoaderTheme, ModalButtons } from '@fcom/ui-components';
import { FinnairPassengerItem } from '@fcom/dapi/api/models';
import { ETicketReceiptResponseData, SubmitService } from '@fcom/service-forms';
import {
  CommonBookingFeatureState,
  orderDataPrimaryPassenger,
  PassengerNameRecord,
  PNR,
} from '@fcom/common-booking/store';
import { unsubscribe } from '@fcom/core/utils';

enum EticketOrderStatus {
  INITIAL,
  IN_PROGRESS,
  COMPLETE,
  ERROR,
}

@Component({
  selector: 'fin-mmb-passenger-order-eticket',
  templateUrl: './passenger-order-eticket.component.html',
  styleUrls: ['../../../../../common-booking/assets/helper-classes.scss'],
  standalone: false,
})
export class ManageBookingPassengerOrderEticketComponent implements OnInit, OnDestroy {
  readonly ModalButtons = ModalButtons;
  readonly ButtonTheme = ButtonTheme;
  readonly ButtonSize = ButtonSize;
  readonly LoaderTheme = LoaderTheme;
  readonly Status = EticketOrderStatus;

  mainPaxInfo$: Observable<FinnairPassengerItem>;
  isOpen = false;
  status$: Subject<EticketOrderStatus> = new Subject();

  private subscriptions = new Subscription();

  constructor(
    private store: Store<CommonBookingFeatureState>,
    private submitService: SubmitService
  ) {}

  ngOnInit(): void {
    this.mainPaxInfo$ = this.store.pipe(orderDataPrimaryPassenger());
  }

  ngOnDestroy(): void {
    this.subscriptions = unsubscribe(this.subscriptions);
  }

  openModal(): void {
    this.isOpen = true;
    this.status$.next(EticketOrderStatus.INITIAL);
  }

  orderTickets(): void {
    this.status$.next(EticketOrderStatus.IN_PROGRESS);
    this.subscriptions.add(
      this.store
        .pipe(
          PNR(),
          take(1),
          switchMap((PNR: PassengerNameRecord) =>
            this.submitService.eTicketReceipt({
              eTicketReceipt: {
                lastName: PNR.lastName,
                reservationNumber: PNR.recLoc,
              },
            })
          )
        )
        .subscribe({
          next: (_: ETicketReceiptResponseData) => {
            this.status$.next(EticketOrderStatus.COMPLETE);
          },
          error: () => {
            this.status$.next(EticketOrderStatus.ERROR);
          },
        })
    );
  }
}
